<template>
  <div>

    <div style="      height: 100vh;    overflow: hidden;">
      <div class="main">
        <a-layout style="    height: 100%;   ">
          <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible width="9rem" id="mainMenu"
            style="    border-radius: 10px;">
            <div class="logo"><img src="../assets/logo.png" /></div>
            <a-menu v-model:openKeys="openKeys" :selectable="false" v-model:selectedKeys="selectedKeys" id="menu">

              <template v-for="item, index in menuList" v-bind:key="index">
                <template v-if="item">
                  <a-menu-item :key="item.key" @click="toLeftClick(item.key, 0)" style="    height: auto;">


                    <div
                      style="display: flex;align-items: center;text-align: center;padding: 8px 0px;justify-content: center;"
                      :class="{'menuitem':true,'menuitemclose':collapsed==true?false:true}">
                      <div style="width: 100%;">
                        <div style="line-height: normal;"
                          :class="{ 'icon-right': unreadCountNum > 0 && item.name == '评论中心' && collapsed == true }">
                          <svg-icon :name="item.name" :color="item.key == selectedKeys[0] ? '#0496AF' : 'white'" :mr="0"
                            :size="24"></svg-icon>
                        </div>
                        <!-- <div v-if="item.name == 'AI洞察'||item.name == 'AI搜索'">
                              <div :class="{'beta':true,'active':item.key == selectedKeys[0]?true:false}">beta版</div>
                        </div> -->


                        <div v-if="item.name == '评论中心'">
                          <div style="position: relative;">
                            <div style="line-height: normal;color: white; font-size: 14px;" class="menu-subTitle">{{
                              item.name }}</div>
                            <div class="commentStyle" v-if="unreadCountNum > 0" style="    position: absolute;
       right: -5px;
    top: 0px;">
                              <span v-if="unreadCountNum > 999">999+</span>
                              <span v-else>{{ unreadCountNum }}</span>

                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div style="line-height: normal;color: white; font-size: 14px;" class="menu-subTitle">{{
                            item.name }}</div>
                        </div>
                      </div>

                    </div>

                  </a-menu-item>
                </template>
                <!-- <template v-else>
                  <a-sub-menu :key="item.key">
                    <template #title>
                      <svg-icon :name="item.name" color="black" :mr="1"></svg-icon>{{ item.name }}
                    </template>
                    <template v-for="menuChildren in item.children" :key="menuChildren.key">
                      <a-menu-item class="aselectStyle" @click="toLeftClick(menuChildren.key, 1)">{{ menuChildren.name
                        }}</a-menu-item>
                    </template>
                  </a-sub-menu>
                </template> -->
              </template>
              <!--     
              <div style="position: absolute;bottom: 40px;width: 100%;">
                <div v-if="collapsed" @click="toggleCollapsed">
                <MenuUnfoldOutlined       style="color: white;font-size:20px" />
               
              </div>
              <div v-else @click="toggleCollapsed">
                <MenuFoldOutlined    style="color: white;font-size:20px" />
              </div>
              </div> -->


            </a-menu>
            <div style="position: absolute;bottom: 20px;width: 100%;" @click="toggleCollapsed">
              <div style="width: 100%;display: flex;justify-content: center;cursor: pointer;">
                <MenuUnfoldOutlined v-if="collapsed" style="color: white;font-size:20px" />
                <MenuFoldOutlined v-else style="color: white;font-size:20px"></MenuFoldOutlined>
              </div>
            </div>
          </a-layout-sider>
          <a-layout>
            <a-layout-content id="layoutContent" style="display: flex
;
    flex-direction: column;">
              <a-layout-header style="background: white;padding:0px;height: min-content;
    line-height: normal;box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
    border-bottom: 1px solid #dddddd;">
                <div class="titleMenu" :style="{'padding-left':backFlag?'18px':'20px'}">
    <ArrowLeftOutlined  v-if="backFlag" style="margin-right: 2px;" class="backIcon" @click="toBackTo"/>
                  <div class="active-menu-title">{{ selectName }}</div>
                  <div style="margin-left: auto;    display: flex;">

                    <div style="display: flex;align-items: center;justify-content: center;margin-right: 50px;">
                      <img src="../assets/企业.png" style="    width: 26px;
    margin-right: 5px;" />
                      <template v-if="changeShow == false">
                        <div style="color:#00bcd4;">{{ companyName }}</div>
                        <a style="margin-left: 10px" @click="changeShow = true">切换</a>
                      </template>
                      <template v-else>
                        <a-select v-model:value="companyValue" :options="companyListOptions" @change="toChange"
                          style="width: 500px;"></a-select>
                        <a style="margin-left: 10px" @click="changeShow = false">取消</a>

                      </template>
                    </div>
                    <a-dropdown>
                      <div> <img style="width:26px;margin-right: 5px;border-radius:50% ;height: 26px;"
                          :src="avatarSrc && avatarSrc != null && avatarSrc != 'null' ? avatarSrc : emptyAvatar" />
                        <DownOutlined />
                      </div>
                      <template #overlay>
                        <a-menu>
                          <a-menu-item key="1" style="color:gray">{{lang=='en'?'Login name: ':'登陆名： '}}{{ loginName }}</a-menu-item>
                          <a-menu-item key="2" @click="toModifyPassword(true)">修改密码</a-menu-item>
                          <a-menu-item key="3" @click="loginOut">{{lang=='en'?'Login Out':'退出登陆' }}</a-menu-item>
                        </a-menu>
                      </template>
                    </a-dropdown>
                  </div>
                </div>
              </a-layout-header>

              <div style="height: 100%;display: flex;flex-grow: 1;background: white;" id="mainContent">
                <div v-if="toShowSub()">
                  <a-menu v-model:openKeys="openKeysArticleType" :selectable="false"
                    v-model:selectedKeys="selectedKeysArticleType" id="menuArticleType" theme="light" mode="inline"
                    style="height: 100%;width: 9rem;">
                    <template v-for="item, index in menuListArticleType" v-bind:key="index">
                      <template v-if="item && item.child == false">
                        <a-menu-item :key="item.key" @click="toLeftClick(item.key, 0)">
                          <template #icon>
                            <svg-icon :name="item.name" :mr="0" :size="20" :color="selectedKeys == item.key ? '#009da6' : 'black'
                              "></svg-icon>

                          </template>
                          <div style="display: flex;    align-items: center;">
                            <div style="  font-size: 13px; ">{{ item.name }}</div>

                          </div>
                        </a-menu-item>
                      </template>
                      <template v-else>
                        <a-sub-menu :key="item.key">
                          <template #title>
                            <div style="display: flex;    align-items: center;">
                              <svg-icon :name="item.name" color="black" :mr="0"></svg-icon>
                              <span style="    margin-left: 10px;font-size: 13px;">{{ item.name }}</span>
                              <!-- <div style="    margin-left: 10px;">{{ item.name }}</div> -->
                            </div>


                          </template>
                          <template v-for="menuChildren in item.children" :key="menuChildren.key">
                            <a-menu-item class="aselectStyle" @click="toLeftClick(menuChildren.key, 1)"
                              style="font-size: 13px;">{{
                                menuChildren.name
                              }}</a-menu-item>
                          </template>
                        </a-sub-menu>
                      </template>
                    </template>
                  </a-menu>
                </div>


                <router-view #default="{ Component, route }">
                  <keep-alive>
                    <component :is="Component" :key="route.name" v-if="route.meta.keepAlive" />
                  </keep-alive>
                  <component :is="Component" :key="route.name" v-if="!route.meta.keepAlive" />
                </router-view>
              </div>
              <BackButton ></BackButton>

            </a-layout-content>

          </a-layout>

        </a-layout>

      </div>
    </div>
  
  </div>
  <a-modal v-model:visible="concatVisible" title="" centered :closable="false" :footer="null" :width="200">
    <div style="text-align: center;">
      <img src="https://enplus.oss-cn-guangzhou.aliyuncs.com/file/82831437-bb77-4c29-9971-f4286c671f5c.jpg"
        style="width:100px" />
      <div class="text">扫描二维码</div>
      <div class="text">添加我的企业微信</div>
    </div>
    <div></div>
  </a-modal>
  <modifyPasswordComponent :modifyPasswordVisible="modifyPasswordVisible" @toModifyPasswordVisible="toModifyPassword"></modifyPasswordComponent>
</template>
<script>
import { message } from 'ant-design-vue/lib/components'
import Font from '../components/articleComponent/Font.vue'
import { Modal } from 'ant-design-vue';
import { getArticleCategory, getResult, unreadCount } from './js/index'
import { ArrowLeftOutlined,DownOutlined, ExclamationCircleOutlined, UserOutlined, VideoCameraOutlined, UploadOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue';
import { defineComponent, ref, watch, createVNode, onMounted, nextTick, onUnmounted, computed, reactive, toRefs } from 'vue';
import store from '@/store';
import router from '@/router';
import { useRouter } from 'vue-router';
import { setInterval } from 'core-js';
import { showManagerUserPage } from '@/untils/index'
import BackButton from '@/components/backButton.vue';
import { showAIknowledge, showWebSearch, toGetAIConfig,showReportLibrary } from '@/untils/company';
import modifyPasswordComponent from '@/components/modifyPasswordComponent.vue'
import { toGetApp } from '@/untils/knowledege';
export default defineComponent({
  components: {
    modifyPasswordComponent,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    DownOutlined,
    Font,
    BackButton,
    ArrowLeftOutlined
  },
  setup() {
    const $router = useRouter();
    const companyName = ref('')
    const selectedKeys = ref(['/main'])
    const avatarSrc = ref(null)
    
    const selectedKeysArticleType = ref([''])
      const timer = ref(null)
    const toSetTimer = () => {
      console.log(store.getters.taskList)
      if (store.getters.taskList && store.getters.taskList.length > 0 && store.getters.taskList[0]) {

        timer.value = setInterval(() => {
          toGetStatus()
        }, 2000);
      }
      else {
        clearInterval(timer.value)
        timer.value = null
      }
    }
    const companyListOptions = ref([])
     const changePageStyle = (val) => {
      // if (val == '/QiuuPageDetail') {
      //   document.getElementById('mainContent').classList.add('QbgPage')

      // }
      // else {
      //   document.getElementById('mainContent').classList.remove('QbgPage')
      // }
    }
    const toGetStatus = () => {

      var list = store.getters.taskList

      if (list && list.length > 0 && store.getters.taskList[0] && store.getters.taskList[0].toString() != '') {
        getResult({ key: store.getters.taskList[0] }).then((res) => {
          if (res.data == 1) {
            message.success('导出成功，请在“导出情报”中下载')
            list.splice(0, 1)
            store.dispatch('taskListRest', list)
          }

        })
      }
      else {
        if (list && list.length > 0) {
          list.splice(0, 1)
          store.dispatch('taskListRest', list)
        }
        clearInterval(timer.value)
        timer.value = null
      }
    }

    const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
    const intervalGetUnRead = ref(null)
    const storeCompany = computed(() => {
      if (store.getters.company)
        return store.getters.company
      else return {}
    })
      const setBackFlag=()=>{
    
       if(router.currentRoute.value.path.indexOf('knowledgeManageDetail')>-1)
       backFlag.value=true
      else      backFlag.value=false
    }
    const reloadData = async () => {

      //获取 div 元素  
      // var height = document.getElementById('container').offsetHeight
      // scrollView.value = { height: (height - 50) + 'px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }

      if (store.getters.company.companyType == 4) {
        store.dispatch('toGetUserfor')
        toGetUserInfor()
        companyName.value = store.getters.company.companyName

      }

      if (store.getters.INTSort && store.getters.INTSort != '') {
        companyName.value = store.getters.company.companyName

        toGetArticleCategory()
      }
      else {
        store.dispatch('toGetUserfor')
         toGetUserInfor()
      }
      nextTick(() => {

        avatarSrc.value = store.getters.avatar
        toGetArticle()
      })
      console.log(intervalGetUnRead.value, 'intervalGetUnRead')
      if (intervalGetUnRead.value == null && router.currentRoute.value.path != '/commentPage' && store.getters.company.companyType != 4 && store.getters.company.manager == 1) {
        intervalGetUnRead.value = setInterval(() => {
          toGetUnReadCount()
        }, 10000)
      }

      changePageStyle(router.currentRoute.value.path)


      companyValue.value = store.getters.company.companyId
      if (store.getters.companyList && store.getters.companyList instanceof Array) {
        toGetCompanyList(store.getters.companyList)
      }
      else {
        await store.dispatch('toGetUserforCompanyList')
        nextTick(() => {
          toGetCompanyList(store.getters.companyList)
        })
      }


    }
    const toGetCompanyList = (companyList) => {
      var list = []
      for (var i in companyList) {
        list.push({ label: companyList[i].companyName, value: companyList[i].companyId })
      }

      companyListOptions.value = list
    }
   
 
    onMounted(() => {
    

      if (storeCompany.value.companyId){
        reloadData()
        toGetAIConfig(store.getters.company)
        setBackFlag()
      }
       


    })
  

    onUnmounted(() => {

      if (timer.value)
        clearInterval(timer.value)
      timer.value = null
      if (intervalGetUnRead.value)
        clearInterval(intervalGetUnRead.value)
      intervalGetUnRead.value = null


    })
    const unreadCountNum = ref(0)
    const toGetUnReadCount = () => {
      unreadCount({ id: store.getters.company.companyId }).then((res) => {
        unreadCountNum.value = res.data
        console.log(res)
      })

    }
    
    const toGetUserInfor = () => {
      console.log(store.getters.company,'store.getters.company')
      menuList.value = JSON.parse(JSON.stringify(menuListOrign.value))
      companyName.value = store.getters.company.companyName

      var index = menuList.value.find(item => item.name == '阅读统计')
      if (index > -1) {
        menuList.value.splice(index, 0)
      }
      var index = menuList.value.find(item => item.name == '评论中心')
      if (index > -1) {
        menuList.value.splice(index, 0)
      }
      toGetArticleCategory()
    }
    const toGetArticleCategory = () => {
      getArticleCategory({ id: store.getters.company.companyId }).then((res) => {
        toSetMenu(res.data, 0)
      })
    }
    const menuListArticleType = ref([
    {
        child: false,
        children: [],
        key: '/mySubscribe',
        name: '我的订阅'
      },
      {
        child: true,
        children: [],
        key: '/INT',
        name: '全部'
      },
      {
        child: false,
        key: '/reportLibrary',
        name: '报告库'
      },

    ])
   
    const toSetMenu = async (val, key) => {
      var exportFlag = false
 

      

      if (store.getters.company.companyType != 4 && store.getters.company.manager == 1) {

        toSetComment()


        if (menuList.value && menuList.value.find(item => item.name == '导出情报') == null)
          menuList.value.push({
            child: false,
            key: '/exportReport',
            name: '导出情报'
          })
        if (menuList.value && menuList.value.find(item => item.name == '阅读统计') == null)
          menuList.value.push({
            child: false,
            key: '/read',
            name: '阅读统计'
          })
        if (showManagerUserPage(store.getters.company.companyType) && menuList.value && menuList.value.find(item => item.name == '管理用户') == null) {
          menuList.value.push({
            child: false,
            key: '/manageUserPage',
            name: '管理用户'
          })
        }
      }
      else {
        if (store.getters.company.companyType == 4) {
          toSetComment()
          if (store.getters.company.vip == 4 || store.getters.company.vip == 2) {
            if (store.getters.company.vip == 4 && !menuList.value.find(item => item.key == '/person')) {
              menuList.value.push({
                child: false,
                key: '/person',
                name: '人员管理'
              })
            }
            if ((store.getters.company.vip == 2 || store.getters.company.vip == 4) && !menuList.value.find(item => item.key == '/keyword'))
              menuList.value.push({
                child: false,
                key: '/keyword',
                name: '关键词设置'
              })
            if (!menuList.value.find(item => item.key == '/concat'))
              menuList.value.push({
                child: false,
                key: '/concat',
                name: '联系客户经理'
              })
            if (!menuList.value.find(item => item.key == '/ticket'))
              menuList.value.push({
                child: false,
                key: '/ticket',
                name: '申请开票'
              })

            if (!menuList.value.find(item => item.key == '/exportReport'))
              menuList.value.push({
                child: false,
                key: '/exportReport',
                name: '导出情报'
              })
          }
        }
        toSetComment()
      }
       var knowledgeAPPList= await toGetApp()
      if (knowledgeAPPList.length>0&& store.getters.company.manager == 1&&menuList.value && menuList.value.find(item => item.name == '知识库管理') == null)
        
      
          menuList.value.push({
            child: false,
            key: '/knowledgeManage',
            name: '知识库管理'
      })
      // if (!menuList.value.find(item => item.key == '/QiuuPage'))
      //   menuList.value.push({
      //     child: false,
      //     key: '/QiuuPage',
      //     name: 'Qiuu~AI分析'
      //   })
      var list = []
      for (var i in val) {
        list.push({
          key: val[i].name,
          name: val[i].name,
        })
      }

      store.dispatch('INTSort', val)
      nextTick(() => {
        store.dispatch('INTSortChange', true)
        menuListArticleType.value[1].children = list
        console.log('xixi', list, menuListArticleType.value)
        // menuList.value[1].children = list
        toSetSelectKey()
      })

    }

    //评论中心
    const toSetComment = () => {
      if (menuList.value && menuList.value.find(item => item.name == '评论中心') == null)
        menuList.value.push({
          child: false,
          key: '/commentPage',
          name: '评论中心'
        })
    }

    const selectName = ref("")
    const toSetSelectKey = (val) => {
      var sortList = store.getters.INTSort
      console.log(sortList, 'toGetArticleCategory')
      if (sortList && $router.currentRoute.value.path == '/INT') {
        if ($router.currentRoute.value.query && $router.currentRoute.value.query.category && sortList.find(item => item.name == $router.currentRoute.value.query.category)) {

          openKeys.value = ['/INT']
          openKeysArticleType.value = ["/INT"]
          selectedKeysArticleType.value = [$router.currentRoute.value.query.category]
          selectedKeys.value = ['/main']

        }
        else {
          selectedKeys.value = ['/main']
          selectedKeysArticleType.value = ['main']
          openKeysArticleType.value = ["/INT"]
          if (val != null)
            router.push('/main')
        }
      }
      else if ($router.currentRoute.value.path == 'articleDetail') {
        selectedKeys.value = []
        selectedKeysArticleType.value = []
      }
      else if ($router.currentRoute.value.path == 'catalogArticleDetail') {
        selectedKeys.value = []
        selectedKeysArticleType.value = []
      }
      else {
        selectedKeys.value = [$router.currentRoute.value.path]
        selectedKeysArticleType.value = [$router.currentRoute.value.path]
        openKeysArticleType.value = [$router.currentRoute.value.path]
        if (openKeysArticleType.value == '/main' || selectedKeysArticleType.value == '/reportLibrary'||selectedKeysArticleType.value == '/mySubscribe' || selectedKeysArticleType.value[0] == '/articleDetail' || selectedKeysArticleType.value[0] == '/catalogArticleDetail') {
          openKeysArticleType.value = ["/INT"]
          selectedKeys.value = ['/main']
        }



      }
      console.log(menuList.value,'xix',selectedKeys.value[0])
      selectName.value = menuList.value.find(item => item.key == selectedKeys.value[0]) != null ? menuList.value.find(item => item.key == selectedKeys.value[0]).name : ''
      if ($router.currentRoute.value.path.indexOf('KnowledgeDetail') > -1) {
        selectName.value = "AI洞察"
        selectedKeys.value = ['/AIKnowledgeBase']
      }
      else if ($router.currentRoute.value.path.indexOf('knowledgeManageDetail') > -1) {
        selectName.value = "知识库管理"
        selectedKeys.value = ['/knowledgeManage']
      }

    }
    const menuListOrign = ref([
      {
        child: false,
        key: '/main',
        name: '情报中心'
      },
      // {
      //   child: true,
      //   children: [],
      //   key: '/INT',
      //   name: '情报分类'
      // },
      // {
      //   child: false,
      //   key: '/reportLibrary',
      //   name: '报告库'
      // },
      // {
      //   child: false,
      //   key: '/AIKnowledgeBase',
      //   name: 'AI洞察',
      // },
      // {
      //   child: false,
      //   key: '/AISearch',
      //   name: 'AI搜索',
      // },
      {
        child: false,
        key: '/favor',
        name: '我的收藏',
      }
    ])
    const menuList = ref([
      {
        child: false,
        key: '/main',
        name: '情报中心'
      },
      // {
      //   child: false,
      //   key: '/AIKnowledgeBase',
      //   name: 'AI洞察',
      // },
      // {
      //   child: false,
      //   key: '/AISearch',
      //   name: 'AI搜索',
      // },
      {
        child: false,
        key: '/favor',
        name: '我的收藏',
      }
    ])

    const toSetAIMenu=()=>{

      console.log('toSetAIMenu',store.getters.company)
      if(store.getters.company&&showAIknowledge(store.getters.company.companyType,store.getters.company.companyId)){
        if (menuList.value && menuList.value.find(item => item.name == 'AI洞察') == null)
          menuList.value.splice(1,0,{
       child: false,
       key: '/AIKnowledgeBase',
       name: 'AI洞察',
       })
     
      }

      if(showWebSearch()&& menuList.value.find(item => item.name == 'AI搜索') == null){
        var splictIndex=2
        if(menuList.value.find(item=>item.name=='AI洞察')==null) splictIndex=1
        menuList.value.splice(splictIndex,0, {
       child: false,
       key: '/AISearch',
        name: 'AI搜索',
       })
      
      }
      toSetReportLibrary()



    }
    const toSetReportLibrary=()=>{
     
      if(showReportLibrary()){
        if (menuListArticleType.value && menuListArticleType.value.find(item => item.name == '报告库') == null)
        menuListArticleType.value.splice(2,0,{
         child: false,
        key: '/reportLibrary',
        name: '报告库',
        })
      }
      else{
        var index=menuListArticleType.value.findIndex(item=>item.name=='报告库')
        if(index>-1)
        menuListArticleType.value.splice(index,1)
      }
    }

    const company = ref(null)
 

    const toLeftClick = (val, key) => {
      if (val == '/concat') {
        concatVisible.value = true
      }
      else if (key == 0) {
        router.push(val)
      }
      else if (key == 1)
        router.push({ name: 'INT', query: { category: val } })
    }
    const scrollView = ref({})

    const openKeys = ref([])
    const openKeysArticleType = ref([])
    const loginOut = () => {
      Modal.confirm({
        title: '退出账号操作',
        icon: createVNode(ExclamationCircleOutlined),
        content: () =>
          createVNode(
            "div",
            {
              style: "color:red;",
            },
            "确定要退出当前账号？"
          ),
        okText: () => "确定",
        cancelText: () => "取消",
        onOk() {
          store.dispatch("exitAccount", null);
        }
      })
    }
    const toGetArticle = () => {
      loginName.value = store.getters.company.loginName
      console.log(store.getters.company.loginName, 'store.getters.company.loginName')
    }
    const loginName = ref(0)
    const shareCount = ref(0)
  
    const concatVisible = ref(false)
    const changeShow = ref(false)

    const companyValue = ref('')
    const toChange = () => {
      changeShow.value = false
      store.dispatch('changeCompany', companyValue.value)

    }
    const state = reactive({
      collapsed: false,
    }
    )
    const collapsed1 = ref(false)
    const toggleCollapsed = () => {
      state.collapsed = !state.collapsed;


      // state.openKeys = state.collapsed ? [] : state.preOpenKeys;
    };
    const toShowSub = () => {
      var flag = false;
      console.log(selectedKeysArticleType.value[0], menuListArticleType.value[0].children, 'xixixi')
      if (selectedKeysArticleType.value[0] == '/main' || selectedKeysArticleType.value[0] == '/reportLibrary' || selectedKeysArticleType.value[0] == '/mySubscribe'||
        selectedKeysArticleType.value[0] == '/articleDetail' || selectedKeysArticleType.value[0] == '/catalogArticleDetail'
      )
        flag = true
      else for (var i in menuListArticleType.value) {
        if (menuListArticleType.value[i].child == true) {
          for (var ii in menuListArticleType.value[i].children) {
            if (menuListArticleType.value[i].children[ii].key == selectedKeysArticleType.value[0]) {

              flag = true
              break
            }
          }
        }
        else if (flag == false) {
          if (menuListArticleType.value[i].key == selectedKeysArticleType.value[0]) {

            flag = true
            break
          }
        }
        if (flag == true) break



      }
      return flag

    }
    const modifyPasswordVisible=ref(false)
    const toModifyPassword=(value)=>{
      modifyPasswordVisible.value=value
    }
    const backFlag=ref(false)
    const toBackTo=()=>{
    router.push({path:'knowledgeManage'})
    }
         watch(
      () => $router.currentRoute.value.query,
      (val) => {
        if (val) {
          toSetSelectKey()
        }
      })
   
    watch(
      () => $router.currentRoute.value.path,
      (val) => {

        changePageStyle(val)

        console.log(val, 'val')
        if (val && val == '/commentPage') {
          console.log('commentPagecommentPage', intervalGetUnRead.value)
          unreadCountNum.value = 0
          if (intervalGetUnRead.value)
            clearInterval(intervalGetUnRead.value)
          intervalGetUnRead.value = null


        }
        else {
          if (intervalGetUnRead.value == null && store.getters.company.companyType != 4 && store.getters.company.manager == 1) {
            intervalGetUnRead.value = setInterval(() => {
              toGetUnReadCount()
            }, 10000)
          }
        }
        setBackFlag()

      })
    watch(
      () => store.getters.reloadFlag,
      (val) => {
        if (val == true) {
          store.dispatch('INTSort', null)
          toGetUserInfor()
        }
      })
  

    watch(
      () => store.getters.taskList,
      (val) => {

        if (val != null) {

          if (val[0] != '' && val[0]) {
            toSetTimer()
          }
          else {
            if (timer.value)
              clearInterval(timer.value)
            timer.value = null
          }
        }
      },
      { deep: true, immediate: true }
    );

    watch(() => storeCompany.value.companyId, (val) => {
      
      if (val){
        reloadData()
        toGetAIConfig(store.getters.company)
      } 

    })
    watch(() => store.state.AIConfig, (val) => {
       
        toSetAIMenu()
      

  },{immediate: true,deep: true})
    return {
      toBackTo,
      backFlag,
      modifyPasswordVisible,
      toModifyPassword,
      selectName,
      toShowSub,
      selectedKeysArticleType,
      openKeysArticleType,
      menuListArticleType,
      toggleCollapsed,
      ...toRefs(state),
      toChange,
      companyValue,
      companyListOptions,
      changeShow,
      intervalGetUnRead,
      unreadCountNum,
      toGetUnReadCount,
      avatarSrc,
      emptyAvatar,
      toSetTimer,
      timer,
      toGetStatus,
      menuListOrign,
      concatVisible,
  

      shareCount,
      loginName,
      loginOut,
      toGetArticle,
      toSetSelectKey,
      scrollView,
      toLeftClick,
      companyName,
      toGetUserInfor,
      toGetArticleCategory,
      company,
      menuList,
      openKeys,
      selectedKeys,

    };
  },
});
</script>
<style>
.ant-menu-sub.ant-menu-inline {
  background: white !important;
}

.ant-btn-primary[disabled] {
  color: #a2d8da !important;
  background: #a2d8da!important;
  color: white!important;
}
</style>
<style lang="less">
#menu.ant-menu-inline-collapsed {
  .ant-menu-item-selected {
    margin-left: 0px !important;
  }

}
</style>
<style lang="less" scoped>
.titleMenu{
  background: white; display: flex;
    /* width: 100%; */
    align-items: center;font-size: 14px;
    padding: 8px 20px;
}
.menuitemclose{
  .icon-right::after {
    display: none;
  }
}
.beta{
  font-size: 10px;
    top: 0px;
    background: white;
    color: #745DE4;
    width: -webkit-max-content;
    right: 15px;
    width: -moz-max-content;
    width: max-content;
    padding: 2px 6px;
    margin-left: 10rpx;
    /* border: 1px solid #745DE4; */
    border-radius: 5px;
    font-size: 9px;
    position: absolute;
    top: 4px;

    background: white;
    color: #0496af;
    line-height: normal;
}
.beta.active{
  color: white;
  background: #0496af;
}
@media (max-width: 1400px) {
  .menu-subTitle {
    margin-top: 0px !important;
  }

  .menuitem {
    padding: 3px 0px !important;
  }


}

.ant-tooltip-inner {
  .commentStyle {
    display: none;
  }

  .icon-right::after {
    display: none;
  }
  .beta{
    display: none;
  }
}

.menu-subTitle {
  margin-top: 3px;
}

#menu.ant-menu-inline-collapsed {
  .beta{
    display: none;
  }
  .ant-menu-title-content {
    .svg-icon {
      color: white !important;
    }
  }

  .menu-subTitle {
    display: none;
  }

  .commentStyle {
    display: none;
  }

  .ant-menu-item-selected {

    .svg-icon {
      color: #0496AF !important;
    }

  }


}

#menu {
  .ant-menu-title-content {
    .svg-icon {
      color: white !important;
    }
  }

  .ant-menu-item-selected {
    .menu-subTitle {
      color: #0496AF !important;
    }

    .menuitem {
      padding-right: 10px !important;
    }

    .svg-icon {
      color: #0496AF !important;
    }
  }

}

.icon-right::after {
  content: '';
  position: absolute;
  top: 6px;
  right: 25px;
  width: 7px;
  height: 7px;
  background-color: red;
  border-radius: 50%;
}

.commentStyle {
  background-color: red;
  color: white;
  border-radius: 25px;
  height: 20px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  margin-left: 5px;

}

.Qbg {
  background: url('../assets/Qbg2.png') 50% / cover no-repeat !important;

}



.QbgPage {
  background-color: #f0f2f5 !important;
  padding: 0px !important;
  overflow: hidden;
}

#menu :deep(.aselectStyle) {
  .ant-menu-title-content {
    padding: 0 12px !important
  }
}



#menu :deep(.ant-menu.ant-menu-inline-collapsed) {
  .ant-menu-item {
    padding: 0 calc(50% - 8px);
  }
}


</style>
<style lang="less">
@import "../assets/main.less";

#menu {
  .ant-menu-item-selected span div div:nth-child(2) {
    color: #0496AF !important;
  }

  .ant-menu-item:not(:last-child) {

    margin: 10px 0px
  }

  .ant-menu-item:first-child {

    margin-top: 0px !important;
  }
}

.ant-menu-submenu-selected {
  color: @primary-color !important;
}

.ant-menu-light .ant-menu-item:hover {
  color: @primary-color !important;
}

.ant-menu-light .ant-menu-submenu-title:hover {
  color: @primary-color !important;
}
</style>
<style scoped>

#menu {
  background: transparent !important;
  border-right: 0px !important
}


#menu :deep(.ant-menu-title-content) {
  margin-left: 0px;
}

#menu :deep(.ant-menu-item:active) {
  background-color: #235053;
}



#menu :deep(.ant-menu-item::after) {
  border-right: 3px solid #009da6 !important;
}

#menu :deep(.ant-menu-submenu-active) {
  color: #3db4bb;
}

#menu :deep(.ant-menu-item:focus) {
  background-color: #00b1b8;
}

/*#menu /deep/ .ant-menu-submenu-active{
 color: #3db4bb ;
}*/
#menu :deep(.ant-menu-item:hover) {
  background-color: #20a4aa;
}

#menuArticleType {
  overflow-y: auto;
  overflow-x: hidden;
}

#menuArticleType :deep(.ant-menu-item-only-child) {
  padding: 0px !important;
  text-align: center;
}

#menuArticleType li:first-child {
  margin-top: 81px;
}

#menuArticleType :deep(.ant-menu-item) {
  padding-left: auto !important;
  height: 35px !important;
  line-height: 35px !important;

}

#menuArticleType :deep(.ant-menu-item-selected) {
  color: #009da6;
}

#menuArticleType :deep(.ant-menu-item::after) {
  border-right: 3px solid #009da6 !important;
}

/*
#menu /deep/ .ant-menu-item:hover{
  color: #3db4bb ;
}*/
#menu :deep(.ant-menu-submenu-title:hover) {
  color: #3db4bb;
}

/*#menu /deep/ .ant-menu-submenu-title:hover{
  color: #3db4bb ;
}*/
#menu :deep(.ant-menu-item-selected) {
  color: #0496AF;
  background-color: white !important;
  border-radius: 8px 0 0 8px;
  margin-left: 10px
}

#menu :deep(.ant-menu-item) {

  align-items: center;
}

/*#menu /deep/ .ant-menu-item-selected{
  color: #009da6 ;
}*/
#menu :deep(.ant-menu-submenu-selected) {
  color: #009da6;
}

.logo {
  margin: 10px;
  text-align: center;
}

.logo img {
  width: 50%;
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
}





/* 子容器 */
.main {

  height: 100%;
  background-color: white;
  /* 水平垂直居中 */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}




#menu :deep(.ant-layout-sider) {
  max-width: none !important;
}

#mainMenu.ant-layout-sider {
  position: relative;

  background: #0496AF !important;
  transition: all 0.2s;
}

.active-menu-title {
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  font-size: 16px;
}
</style>